import React from 'react';
import TabacMenuInterface from './TabacMenuInterface';
import './App.css';

function App() {
  return (
    <div className="App">
      <TabacMenuInterface />
    </div>
  );
}

export default App;